<template>
  <v-layout row wrap>
    <!--<v-flex xs4>
      <v-btn color="primary" dark>Total Income
        {{$app.formatMoney(100000)}}
        <v-icon dark right>check_circle</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs4>
      <v-btn color="accent" dark>Total Blocked
        {{$app.formatMoney(100000)}}
        <v-icon dark right>check_circle</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs4>
      <v-btn color="success" dark>Total Blocked
        {{$app.formatMoney(100000)}}
        <v-icon dark right>check_circle</v-icon>
      </v-btn>
    </v-flex>-->
    <v-flex xs6>
      <stats-card url="deliveryBills" chart-type="bar" title="Courier Spending"></stats-card>
    </v-flex>
    <v-flex xs6>
      <!--<stats-card url="allBills" chart-type="bar" title="Total Monthly Spending"></stats-card>-->
    </v-flex>
    <v-flex xs6>
      <!--<stats-card url="serviceBills" title="Spending Per Service"></stats-card>-->
    </v-flex>
    <v-flex xs6>
      <!--<stats-card url="shoppingBills" chart-type="bar" title="Shopping Spending"></stats-card>-->
    </v-flex>
    <v-flex xs6>
      <!--<stats-card url="subscriptionBills" chart-type="bar" title="Subscriptions Spending"></stats-card>-->
    </v-flex>
  </v-layout>
</template>

<script>
  import Base from './Base.vue'
  import StatsCard from './StatsCard'

  export default {
    components: {StatsCard},
    name: 'ClientDashboard',
    extends: Base,
    data () {
      return {}
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ClientDashboard.vue